import axios from "axios";
const jsonConfig = require("../../Config.json");

const getAllDivionByOrg = async (id,payload) => {
 
    try {
        const getAllResponse = await axios.post(
          jsonConfig.apiUrl + "getallDivisionbyOrgId/"+ id,payload,
          {
            headers: {
              "x-functions-key": jsonConfig.key,
            },
          }
        );
        return Promise.resolve(getAllResponse);
      } catch (error) {
        return Promise.reject(error);
      }
}

export default getAllDivionByOrg;